import { GroupStandards } from '@/models/progress-report/progress-report';
import { formatTime } from '@/utils/date';
import { getGradeRange } from '@/utils/utils';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'cp-content-activity-card',
    components: {

    },
})

export default class CPContentActivityCard extends Vue {

    // -----------------------------------------------------------------
    // Properties
    @Prop()
    private content: any;

    @Prop()
    private isPdfContent!: boolean;

    // private get competencies() {
    //     return this.content.competencies || [];
    // }

    // --------------------------------------------------------------------
    // Actions

    private onSelectContent(collection: any) {
        collection.id = collection.assessment_id;
        this.$emit('onSelectContent', collection);
    }

    // -------------------------------------------------------------------
    // Methods

    private getGradeRange(value: number) {
        return getGradeRange(value);
    }

    private formatTime(value: number) {
        return formatTime(value);
    }

    private roundUp(value: any) {
       return Math.round(value);
    }

}
